<template>
  <div>
    <fob-label v-if="showLabel" :label="schema.label" :asterisk="asterisk">
      <button class="multi-select-edit-btn" v-if="!schema.onlyCreate && !deactivated" @click="showTableSelect">
        <translate>form.editlink</translate>
      </button>
      <b-icon v-if="type === 'is-danger'" icon="exclamation-circle" type="is-danger"></b-icon>
    </fob-label>
    <div v-if="resourceData && resourceData.length > 0">
      <div v-if="draggable && !deactivated">
        <draggable v-model="resourceData" :options="{ draggable: '.fob-tag', filter: 'button'}">
          <template v-for="(item, i) in resourceData">
            <div :key="i" class="fob-tag">
              <b-field>
                <div expanded class="box control fob-tag-text fob-draggable">
                  <b-icon type="is-lightgray" :icon="schema.icon"></b-icon>
                  <fob-entity-decorator :resourceData="item">
                    {{ item._stringRep }}
                  </fob-entity-decorator>
                </div>
                <b-tooltip square position="is-top" :label="$gettext(`form.xbutton.remove.multiSelect.${schema.field}`)">
                  <button control @click="dropRow(item._id)"
                          class="control button is-aquamarine"
                          style="margin-left: 12px; margin-top: 0px;"
                  >
                    <b-icon icon="times" size="is-small"></b-icon>
                  </button>
                </b-tooltip>
              </b-field>
            </div>
          </template>
        </draggable>
      </div>
      <div v-else>
        <template v-for="(item, i) in resourceData">
          <div :key="i" class="fob-tag" :class="{'fob-tag-deactivated': deactivated}">
            <b-field>
              <div expanded class="box control fob-tag-text fob-undraggable">
                <b-icon type="is-lightgray" :icon="schema.icon"></b-icon>
                <fob-entity-decorator :resourceData="item">
                  {{ item._stringRep }}
                </fob-entity-decorator>
              </div>
              <b-tooltip v-if="!deactivated" square position="is-top" :label="$gettext(`form.xbutton.remove.multiSelect.${schema.field}`)">
                <button control @click="dropRow(item._id)"
                        class="control button is-aquamarine"
                        style="margin-left: 12px; margin-top: 0px;"
                >
                  <b-icon icon="times" size="is-small"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
          </div>
        </template>
      </div>
    </div>
    <b-modal v-if="!deactivated" :active.sync="tableSelectVisible" :canCancel="true" width="1440" has-modal-card>
      <fob-entity-table-select
        v-model="resourceData"
        :route="schema.schema.className"
        :method="schema.finder"
        :field="schema.field"
        :icon="schema.icon"
        :schema="schema.schema"
        :allowCreate="schema.allowCreate"
      ></fob-entity-table-select>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Label from '@/components/form/Label'
import EntityTableSelect from '@/components/form/EntityTableSelect'
import EntityDecorator from '@/components/EntityDecorator'

export default {
  name: 'fob-entity-multi-select',
  data () {
    return {
      tableSelectVisible: false
    }
  },
  computed: {
    showLabel () {
      // since schema.editable might be undefined (which means here: implicitly true),
      // `schema.field === false` is NOT equivalent to `!schema.editable` since the latter
      // is `true` when schema.editable is false or undefined
      if (this.schema.editable === false) {
        return this.resourceData != null && this.resourceData.length !== 0
      } else {
        return true
      }
    },
    resourceData: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    deactivated () {
      if ('editable' in this.schema) {
        return !this.schema.editable
      } else {
        return false
      }
    }
  },
  props: {
    value: Array,
    schema: Object,
    asterisk: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    // currently unused, but ready for action
    // TODO: must also be passed down to the entityTableSelect
    draggable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    dropRow (theid) {
      let newValue = this.resourceData.filter((item) => item._id !== theid)
      this.$emit('input', newValue)
    },
    showTableSelect () {
      this.tableSelectVisible = true
    }
  },
  components: {
    draggable,
    'fob-label': Label,
    'fob-entity-table-select': EntityTableSelect,
    'fob-entity-decorator': EntityDecorator
  }
}
</script>

<style lang="scss">
  // $aquamarine: #8AC2D1;
  $aquamarine: #507D8E;

  .sortable-drag {
    opacity: 0;
  }
  .sortable-chosen {
    transform: translateX(-10px);
  }
  .sortable-chosen .fob-tag-text {
    background-color: $aquamarine;
    color: white;
    font-weight: bold;
  }

  .fob-tag {
    padding: 4px 0px 4px 0px;
  }
  .fob-draggable {
    cursor: move;
  }
  .fob-undraggable {
    cursor: not-allowed;
  }
  .fob-tag-text {
    white-space: nowrap;
    overflow-x: hidden;
    width: 100%;
    padding: 5px 5px 5px 5px;
    margin: 0px !important;
  }
  .fob-tag-deactivated .fob-tag-text {
    background: #f5f5f5;
  }
  .multi-select-edit-btn {
    color: $aquamarine;
    font-size: 1rem;
    padding: 5px 12px;
    margin-left: 5px;
    margin-right: 5px;
    font-weight: bold;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
    outline: transparent;
    cursor: pointer;
  }
  .multi-select-edit-btn:hover {
    border-color: #cacaca;
  }
  .multi-select-edit-btn:focus {
    border-color: $aquamarine !important;
    -webkit-box-shadow: 0 0 0 0.125em rgba(80, 125, 142, 0.25);
    box-shadow: 0 0 0 0.125em rgba(80, 125, 142, 0.25);
  }
</style>



// WEBPACK FOOTER //
// src/components/form/EntityMultiSelect.vue